/**
 * Agent report push notification coordination.
 * localStorage flag bridges push tap → chat UI.
 */

const AGENT_REPORT_KEY = 'xavior:pendingAgentReport';

export function setPendingAgentReport(runId: string): void {
  localStorage.setItem(AGENT_REPORT_KEY, JSON.stringify({ runId, ts: Date.now() }));
}

